import './style.css'
// import * as dat from 'dat.gui'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// import gsap from 'gsap'
import photonsVertexShader from './shaders/vertex.glsl'
import photonsFragmentShader from './shaders/fragment.glsl'

/**
 * Base
 */
// Debug
// const gui = new dat.GUI({
//     width: 400
// })

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Photons
 */
const photonsGeometry = new THREE.BufferGeometry()
const photonsCount = 200
const positionArray = new Float32Array(photonsCount * 3)
const scaleArray = new Float32Array(photonsCount)

for(let i = 0; i < photonsCount; i++)
{
    positionArray[i * 3 + 0] = (Math.random() - 0.5) * 4
    positionArray[i * 3 + 1] = (Math.random() - 0.5) * 2
    positionArray[i * 3 + 2] = (Math.random() - 0.5) * 2

    scaleArray[i] = Math.random()
}

photonsGeometry.setAttribute('position', new THREE.BufferAttribute(positionArray, 3))
photonsGeometry.setAttribute('aScale', new THREE.BufferAttribute(scaleArray, 1))

const photonsMaterial = new THREE.ShaderMaterial({ 
    depthWrite: false,
    blending: THREE.AdditiveBlending,
    transparent: true,
    uniforms:
    {
        uTime: { value: 0 },
        uPixelRatio: { value: Math.min(window.devicePixelRatio, 2) },
        uSize: { value: 20}
    },
    vertexShader: photonsVertexShader,
    fragmentShader: photonsFragmentShader
})

const photons = new THREE.Points(photonsGeometry, photonsMaterial)
scene.add(photons)

/**
 * Rhodonea curves
 */
let group = new THREE.Group()
let group1 = new THREE.Group()

const geo = new THREE.SphereGeometry(0.02,8,8)
const material = new THREE.MeshNormalMaterial()
let k = 5/8

for (let a = 0; a < 360; a+=0.2){
    let r = Math.cos(k * a)
    let x = r * Math.cos(a)
    let y = r * Math.sin(a)

    const sphere = new THREE.Mesh(geo, material)
    sphere.position.set(x, y, 0)
    group.add(sphere)

  }
  group.position.x = -1
  scene.add(group)

  for (let a = 0; a < 360; a+=0.1){
    let r = Math.cos(k * a)
    let x = r * Math.cos(a)
    let y = r * Math.sin(a)

    const sphere = new THREE.Mesh(geo, material)
    sphere.position.set(x, y, 0)
    group1.add(sphere)

  }
  group1.position.x = 1
  scene.add(group1)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    // Update photons
    photonsMaterial.uniforms.uPixelRatio.value = Math.min(window.devicePixelRatio, 2)
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(125, sizes.width / sizes.height, 0.1, 100)
camera.position.y = 0    
camera.position.z = 1.4 
scene.add(camera)

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight()
scene.add(ambientLight)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.outputEncoding = THREE.sRGBEncoding
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor( 0x1a1a1a )

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Animate camera

    // Animate group
    // group.rotation.x = elapsedTime * 0.2
    group.rotation.y = elapsedTime * 0.2
    // group.rotation.z = elapsedTime * 0.2
    
    // group1.rotation.x = -elapsedTime * 0.2
    group1.rotation.y = -elapsedTime * 0.2
    // group1.rotation.z = -elapsedTime * 0.2

    // Animate photons
    photonsMaterial.uniforms.uTime.value = elapsedTime * 0.1

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()